export const screenFormat = {
	desktop: 'desktop',
	mobile: 'mobile'
}
